// extracted by mini-css-extract-plugin
module.exports = {"featured-image-container":"Version_featured-image-container__VdgqO","input-container":"Version_input-container__3CcFY","image-container":"Version_image-container__3hNLu"};